/**
 * @param {unknown[]} segments
 * @returns {string} e.g. "4 segments in 2 documents"
 */
export function formatSegmentsInDocumentsSummary(segments) {
    const list = Array.isArray(segments) ? segments : [];
    const n = list.length;
    const docKeys = new Set();
    list.forEach((s, i) => {
        const rawDoc = s?.docId;
        if (rawDoc != null && String(rawDoc).trim() !== '') {
            docKeys.add(`d:${String(rawDoc)}`);
        } else if (s?.segmentId != null && String(s.segmentId).trim() !== '') {
            docKeys.add(`s:${String(s.segmentId)}`);
        } else {
            docKeys.add(`i:${i}`);
        }
    });
    const d = docKeys.size;
    const segWord = n === 1 ? 'segment' : 'segments';
    const docWord = d === 1 ? 'document' : 'documents';
    return `${n} ${segWord} in ${d} ${docWord}`;
}
